import { render } from "./Wisatadetails.vue?vue&type=template&id=0f025ff9&scoped=true"
import script from "./Wisatadetails.vue?vue&type=script&lang=js"
export * from "./Wisatadetails.vue?vue&type=script&lang=js"

import "./Wisatadetails.vue?vue&type=style&index=0&id=0f025ff9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f025ff9"]])

export default __exports__